import { render, staticRenderFns } from "./PatientRecord.vue?vue&type=template&id=b01ae51e&"
import script from "./PatientRecord.vue?vue&type=script&lang=js&"
export * from "./PatientRecord.vue?vue&type=script&lang=js&"
import style0 from "./PatientRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports